const network = require("./" + process.env.VUE_APP_ENV).default

export default network